import { useState } from 'react';
import { getQueryParams } from '../../publicUtils';
export var useHTTPClientInstance = function (_a) {
    var createHttpClient = _a.createHttpClient;
    var httpClient = useState(function () {
        return createHttpClient === null || createHttpClient === void 0 ? void 0 : createHttpClient({
            isSSR: false,
            getAppToken: function () { return getQueryParams().get('instance'); },
        });
    })[0];
    return httpClient;
};
//# sourceMappingURL=useHTTPClientInstance.js.map